import { render, staticRenderFns } from "./AnnotationDetailsContainer.vue?vue&type=template&id=9390abfe&scoped=true"
import script from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetailsContainer.vue?vue&type=style&index=0&id=9390abfe&prod&scoped=true&lang=scss"
import style1 from "./AnnotationDetailsContainer.vue?vue&type=style&index=1&id=9390abfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9390abfe",
  null
  
)

export default component.exports